import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'normalize.css' // css初始化
import MetricDirective from './directive/metric'
import monitor from './common/monitor'
import env from '@/common/env'

if (env.env === 'test') {
  import(/* webpackChunkName: "coverage-report" */ '@era/coverage-report' as any)
    .then((module) => {
      module.initOrange({ projectKey: 'pay-reward-activity', commitId: process.env.GIT_COMMIT_HASH })
    })
    .catch((error) => {
      console.warn('import coverage-report error:', error)
    })
}

monitor.init()
const app = createApp(App)
app.use(router)
app.directive('metric-mv', MetricDirective.mv)
app.mount('#app')

// 对微信iOS返回页面时不刷新进行兼容
if (env.isWeiXin && env.system === 'ios') {
  window.onpageshow = function (e) {
    if (e.persisted) {
      window.location.reload()
    }
  }
}
